"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LogoWithoutSpace_1 = __importDefault(require("../icons/generated/LogoWithoutSpace"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.AppHeaderContainer = styled_components_1.default.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0 13px;\n  height: 50px;\n  background: ", ";\n  color: ", ";\n  box-sizing: border-box;\n\n  @media (min-width: ", ") {\n    height: 64px;\n    padding: 0 24px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 13px;\n  height: 50px;\n  background: ", ";\n  color: ", ";\n  box-sizing: border-box;\n\n  @media (min-width: ", ") {\n    height: 64px;\n    padding: 0 24px;\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.appHeader.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.appHeader.color;
}, function (_a) {
    var breakpoints = _a.theme.breakpoints;
    return breakpoints.md;
});
exports.AppHeaderContainer.displayName = 'AppHeaderContainer';
exports.FlexWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n"], ["\n  display: flex;\n  align-items: baseline;\n"])));
var AppName = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: 18px;\n  font-size: 16px;\n  line-height: 1;\n"], ["\n  color: ", ";\n  margin-left: 18px;\n  font-size: 16px;\n  line-height: 1;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.appHeader.fadedColor;
});
AppName.displayName = 'AppName';
var AppHeader = function (_a) {
    var title = _a.title;
    return (react_1.default.createElement(exports.AppHeaderContainer, { "data-test-id": "app-header" },
        react_1.default.createElement(exports.FlexWrapper, null,
            react_1.default.createElement(LogoWithoutSpace_1.default, null),
            react_1.default.createElement(AppName, { "data-test-id": "app-header-tile" }, title))));
};
AppHeader.displayName = 'AppHeader';
exports.default = AppHeader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=header.component.js.map